import { api } from '../core';
import { DRAFT_SEARCH_TEXT_TAG } from '../constants';
import type { GetDraftVersionResponse } from './getDraftVersion';

export interface GetDraftSearchTextsRequest {
  draftVersionIds: string[];
}

/** `draftVersionId -> markdown` (citations as `{{id}}`), for chat search. A draft that fails to load is left out. */
export type GetDraftSearchTextsResponse = Record<string, string>;

const getDraftSearchTextsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDraftSearchTexts: builder.query<GetDraftSearchTextsResponse, GetDraftSearchTextsRequest>({
      queryFn: async ({ draftVersionIds }, _api, _extraOptions, baseQuery) => {
        const results = await Promise.all(
          draftVersionIds.map((draftVersionId) =>
            baseQuery({
              url: '/chat/draft/get-version',
              method: 'POST',
              body: { draftVersionId, citationIndexMap: {} },
            }),
          ),
        );

        const data: GetDraftSearchTextsResponse = {};
        draftVersionIds.forEach((draftVersionId, index) => {
          const result = results[index];
          if (result.error) return;
          data[draftVersionId] = (result.data as GetDraftVersionResponse).content ?? '';
        });
        return { data };
      },
      providesTags: [DRAFT_SEARCH_TEXT_TAG],
    }),
  }),
});

export const { useGetDraftSearchTextsQuery } = getDraftSearchTextsApi;
